import React from 'react'
import clsx from 'clsx'

import styles from './cell-radio-group.module.scss'

export interface CellRadioButtonProps extends React.InputHTMLAttributes<HTMLInputElement> {
    label: string
    headline?: string
    name: string
    value: string
}

export const CellRadioButton = React.forwardRef<HTMLInputElement, CellRadioButtonProps>(
    ({ label, value, name, headline, ...props }, ref) => {
        return (
            <div
                className={clsx({
                    [styles['cell-radio-button']]: true,
                    [styles['cell-radio-button--disabled']]: props.disabled,
                })}
            >
                <label className={styles['cell-radio-button__label']} htmlFor={value}>
                    {headline && (
                        <div className={styles['cell-radio-button__headline']}>{headline}</div>
                    )}
                    <div className={styles['cell-radio-button__label-text']}>{label}</div>
                </label>
                <input
                    {...props}
                    ref={ref}
                    aria-disabled={props.disabled}
                    className={styles['cell-radio-button__input']}
                    id={value}
                    name={name}
                    type='radio'
                    value={value}
                />
            </div>
        )
    }
)

CellRadioButton.displayName = 'CellRadioButton'
